<div class="mt-3">
@if (item) {
    <h1>{{ item.displayName }}</h1>
<table class="table">
    <tbody>
    @for (key of keys; track key) {
    <tr>
        <td><b>{{ key }}</b></td>
        <td>{{item[key]}}</td>
    </tr>
    }
    </tbody>
</table>
}
@else {
<span>not found</span>
}
</div>